import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {AppProvider} from "./app.context";
import {IntegratorProvider} from "./integrator.context";

// The desktop-only gate in public/index.html sets this flag before the bundle
// runs. On a phone/tablet, don't mount the app at all — the notice is already shown.
if (!(window as any).__RIFT_DESKTOP_ONLY__) {
  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
  );

  root.render(
    <React.StrictMode>
        <IntegratorProvider>
            <AppProvider>
                <App />
            </AppProvider>
        </IntegratorProvider>
    </React.StrictMode>
  );

  reportWebVitals();
}
